import React from 'react';
import { connect } from 'react-redux';
import { Form } from 'antd';
import { setCurrentLocation, changeMapBounds } from '../../store/actions';
import { getMap } from '../../store/selectors';
import { ActionCreatorType } from 'src/store';
import styles from './RetailerSearch.module.scss';
import { BaseStore } from 'src/store';
import { LocationInput } from 'src/modules/form/field/SearchInput/LocationInput/LocationInput';

interface RetailerSearchProps {
  setCurrentLocation: ActionCreatorType;
  map?: google.maps.Map;
  changeMapBounds: ActionCreatorType;
}

const RetailerSearch: React.FunctionComponent<RetailerSearchProps> = function (
  props: RetailerSearchProps
) {
  const { map, setCurrentLocation, changeMapBounds } = props;

  const [form] = Form.useForm();

  return (
    <div className={styles.container}>
      <Form
        form={form}
        onFinish={(locationData) => {
          if (locationData.location) {
            setCurrentLocation(locationData.location);
            changeMapBounds();
          }
        }}>
        <LocationInput
          form={form}
          map={map}
          name="location"
          searchOnDelete={true}
          placeholderKey="page/store/search/placeholder"
          useCurrentLocationOnMount={true}
        />
      </Form>
    </div>
  );
};

//Get map from redux
const mapStateToProps = (state: BaseStore) => {
  return getMap(state);
};

//Redux state and actions
export default connect(mapStateToProps, {
  setCurrentLocation,
  changeMapBounds,
})(RetailerSearch);
